// extracted by mini-css-extract-plugin
module.exports = {"firstParagraph":"Vehicle_firstParagraph__fBYwB","secondParagraph":"Vehicle_secondParagraph__8Dmhb","otherVehiclesBlockContainer":"Vehicle_otherVehiclesBlockContainer__xDpB1"};